/**
 * @generated SignedSource<<7aba734fce0da0e9f636f222676c2cdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorsTopCreator_topCreator$data = {
  readonly image: string | null;
  readonly name: string | null;
  readonly url: string | null;
  readonly " $fragmentType": "CreatorsTopCreator_topCreator";
};
export type CreatorsTopCreator_topCreator$key = {
  readonly " $data"?: CreatorsTopCreator_topCreator$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsTopCreator_topCreator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorsTopCreator_topCreator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "TopCreator",
  "abstractKey": null
};

(node as any).hash = "8959539616660fa9587460bcba2de704";

export default node;
